<template>
    <div class="account tableStyle">
        <el-card class="card">
            <div class="title flex">
                <span class="sub">资金账户</span>
                <span>
                    <el-button size="mini" v-show="isEdit === false" @click="open">编辑</el-button>
                    <el-button size="mini" v-show="isEdit === true" @click="close">取消编辑</el-button>
                    <el-button size="mini" v-show="isEdit === true" type="primary" @click="edit">保存</el-button>
                </span>
            </div>
            <el-form ref="form" :model="form" :rules="rules" label-width="auto">
                <el-form-item prop="payee_name" label="收款人姓名：">
                    <el-input v-model="form.payee_name" :readonly="isEdit === false"></el-input>
                </el-form-item>
                <el-form-item prop="bank_name" label="开户行名称：">
                    <el-input v-model="form.bank_name" :readonly="isEdit === false"></el-input>
                </el-form-item>
                <el-form-item prop="swift_code" label="开户行行号：">
                    <el-input v-model="form.swift_code" :readonly="isEdit === false"
                        onkeyup="this.value=this.value.replace(/[^\0-9]/g, '').replace(/^0{1}/g, '')">
                        <!-- onkeyup="this.value=this.value.replace(/^[1-9][0-9]{11}$/g, '')"> -->
                    </el-input>
                </el-form-item>
                <!-- ^[1-9][0-9]{11}$ -->
                <el-form-item prop="payee_account" label="收款方银行账号：">
                    <el-input v-model="form.payee_account" :readonly="isEdit === false"></el-input>
                </el-form-item>
                <el-form-item prop="status" label="账户状态：" v-if="'status' in form">
                    {{form.status===1?'审核通过':'审核未通过'}}
                </el-form-item>

                
                <!-- <el-form-item label="手机号：" v-if="isEdit">
                    <el-input v-model.number="mobile" onkeyup="this.value=this.value.replace(/[^\0-9]/g, '')"></el-input>
                </el-form-item>
                <el-form-item label="验证码：" v-if="isEdit">
                    <div class="flex">
                        <el-input v-model="code"></el-input>
                        <el-button type="primary" @click="getCode" :disabled="isCodeSend">
                            {{codeContent}}
                        </el-button>
                    </div>
                </el-form-item> -->
            </el-form>
        </el-card>
    </div>
</template>
<script>
export default{
    data(){
        return{
            isEdit: false,
            originForm: {},
            form:{},
            rules: {
                payee_name: [{
                    required: true, message: '请填写收款人姓名', trigger: 'blur'
                }],
                payee_account: [{
                    type: 'string',
                    required: true, 
                    message: '请填写不以0开头且由16至19位数字组成的银行账号',
                    trigger: 'blur',
                    pattern: /^[1-9][0-9]{15,18}$/g,
                    minlength: 16,
                    maxlength: 19
                }],
                bank_name: [{
                    required: true, message: '请填写银行名称', trigger: 'blur'
                }],
                swift_code: [{
                    required: true,
                    trigger: 'blur',
                    length: 12,
                    pattern: /^[1-9][0-9]{11}$/g,
                    message: '请输入不以0开头的12位数字',
                }],
                // mobile: [{
                //     required: true, message: '请输入负责人手机号', trigger: 'blur'
                // }],
                // code: [{
                //     required: true, message: '请填写验证码', trigger: 'blur'
                // }],
            },

            mobile: '',
            code: '',
            codeContent: '获取验证码',
            isCodeSend: false,
            ddl: 60
        }
    },
    created() {
        this.getForm();
    },
    methods:{
        getForm(){
            this.$http.get(this.common.company+'/company/bankAccount').then(res => {
                if(res.code === 200){
                    // this.form = JSON.parse(JSON.stringify(res.data));
                    this.form = Object.assign({}, res.data);
                    // this.originForm = JSON.parse(JSON.stringify(res.data));
                    this.originForm = Object.assign({}, res.data);
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        open(){
            this.isEdit = true;
            
        },
        close(){
            this.isEdit = false;
            this.form = this.originForm;
            this.$refs.form.clearValidate();
        },
        edit(){
            this.$refs.form.validate(v => {
                if(v===true){
                    // if(this.mobile === ''){
                    //     return this.$message.error('请填写负责人手机号');
                    // }else if(this.code === ''){
                    //     return this.$message.error('请填写验证码')
                    // }else{
                        
                    // }

                    let params = {
                        // mobile: this.mobile,
                        // code: this.code,
                        payee_name: this.form.payee_name,
                        payee_account: this.form.payee_account,
                        bank_name: this.form.bank_name,
                        swift_code: this.form.swift_code
                    };

                    this.$http.post(this.common.company + '/company/bankAccountUpdate', params).then(res => {
                        if(res.code === 200){
                            this.getForm();
                            this.isEdit = false;
                            this.isCodeSend = false;
                            this.codeContent = '获取验证码';
                            this.ddl = 60;
                            this.$message.success('修改成功');
                        }else{
                            return this.$message.error(res.msg);
                        }
                    });
                }
            });
        },
        getCode(){
            if(this.mobile === ''){
                return this.$message.error('请输入手机号码');
            }
            if(this.isCodeSend === true){
                return;
            }else{
                this.$http.post(this.common.company + '/api/sendMobileCode', {
                    mobile: this.mobile
                }).then(res => {
                    if(res.code === 200){
                        this.$message.success('验证码已发送');
                        this.isCodeSend = true;
                        this.codeContent = `${this.ddl}秒后重新发送`;
                        let timer = setInterval(() => {
                            this.ddl--;
                            this.codeContent = `${this.ddl}秒后重新发送`;
                            if(this.ddl <= 0){
                                clearInterval(timer);
                                this.codeContent = '获取验证码';
                                this.ddl = 60;
                                this.isCodeSend = false;
                            }
                        }, 1000);
                    }else{
                        return this.$message.error(res.msg);
                    }
                });
                
            }
        },
    }
}
</script>
<style lang="less" scoped>
.account{
    min-height: calc(100% - 30px);

    .card{
        width: 30%;
        min-width: 450px;
        height: calc(100% - 30px);
        min-height: 600px;

        .title{
            margin-bottom: 20px;
            justify-content: space-between;
            align-items: center;

            .sub{
                font-weight: 500;
            }
        }
    }
}
</style>